import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SuggestionPage from './Suggestion';

const SuggestionModal = ({ show, selectedPerson, onClose, onExited }) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={onClose}
      onExited={onExited}
      centered
      className="d-flex align-items-center"
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("Ieteikt labojumu")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <SuggestionPage selectedPerson={selectedPerson}/>
      </Modal.Body>
    </Modal>
  );
};

export default SuggestionModal;
